
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {ingresoStore} from "@/store/ingresoStore";
import * as stream from "stream";

@Component({
  name: "ingresoNew",
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private ingresoStore = ingresoStore();
  private materialService = MaterialService.getInstance();
  private ingresolService = IngresoService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private isVerFactura = false;
  // private headers = [
  //   {text: "Fecha", value: "fecha"},
  //   {text: "Acción", value: "accion"},
  //   {text: "Usuario", value: "user.email"}
  // ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  historialVisible = false;

  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  ingreso = {
    id: '',
    numero: '',
    numero_pedido: '',
    orden_compra: '',
    tipo: '',
    tipo_id: '',
    fecha_ingreso: DateTime.now().toFormat('yyyy-MM-dd'),
    fecha_orden_compra: DateTime.now().toFormat('yyyy-MM-dd'),
    empresa_proveedora: '',
    responsable_material_funcionario_id: '',
    factura: '',
    nit: '',
    fecha_factura: '',
    solicitud: '',
    certificacion_presupuestaria: '',
    empresa_proveedora_id: ''
  };
  clientes = [];
  materiales = [];
  cliente_seleccionado = null;
  private cuenta = null;

  files = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted(){
    this.getFuncionarioResponsable();
    this.getNuevoCodigo();
    this.getTipo();
    this.getEmpresaProveedora();
  }

  verDocumento() {
      this.ingresolService.imprimirFactura(this.nuevoIngreso.id);
  }
  get historiales(): any[] {
    return this.ingresoStore.historial;
  }

  get ingresoMaterial(): any[] {
    return this.ingresoStore.ingresoMaterial;
  }

  get nuevoIngreso(): any[] {
    return this.ingresoStore.ingreso;
  }
    get loading(): boolean {
    return this.materialStore.loading;
  }

  get esEdiatr(): boolean {
    return this.ingresoStore.esEditar;
  }

  get tipo(): any {
    return this.ingresoStore.tipo;
  }

  get empresaProveedora(): any {
    return this.ingresoStore.empresa;
  }

  getTipo() {
    this.ingresolService.getTipo();
  }

  getEmpresaProveedora() {
    this.ingresolService.getEmpresaPorveedora();
  }

  get nuevoCodigo(): string {
    return this.ingresoStore.nuevoCodigo;
  }

  getNuevoCodigo(){
    this.ingresolService.getNuevoCodigo()
  }

  get sancionNueva(): any[] {
    return this.sancionStore.sancionNueva;
  }
  get cliente(): any[] {
    return this.sancionStore.cliente;
  }
  get funcionarioResponsable(): any {
    return this.ingresoStore.funcionario_responsable;
  }
  getFuncionarioResponsable(){
    this.ingresolService.getFuncionarioResponsable();
  }

  round(value: number) {
    return Math.round(value * 100) / 100;
  }

  getHistoriaL(){
    const data = {
      ingreso: this.nuevoIngreso,
      modelo: 'ingreso',
    };
    this.ingresolService.historial(data);
  }

  getMateriales(value:string) {
    this.loading;
    this.materialService.getMateriales(value);
  }

  @Watch('txtSearch')
  search(value: string) {
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getMateriales(value);
      })
    }
  }
  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar el Ingreso<br>`
    ).then(res => {

      if (res.isConfirmed) {
        if(this.nuevoIngreso.length !== 0){
          const data = {ingresoId:this.nuevoIngreso.id, ingreso:this.ingreso}
          this.ingresolService.updateIngreso(data);
        }else{
          const data = {ingreso:this.ingreso, numero:this.nuevoCodigo}
          this.ingresolService.saveIngreso(data);
        }
        this.$emit('listar')
      }
    })
    // setTimeout(this.getHistoriaL,1500)


  }

  addMaterialIngreso(codigo: string) {
    if (this.cantidad > 0 && this.cantidad_entregada > 0 && this.precio_unitario > 0 && (this.cantidad >= this.cantidad_entregada)) {
      const data = {
        codigo: codigo,
        cantidad: this.cantidad,
        cantidad_entregada: this.cantidad_entregada,
        precio_unitario: this.precio_unitario,
        ingreso: this.nuevoIngreso.numero,
        ingreso_id: this.nuevoIngreso.id
      }
      this.ingresolService.addMaterialIngreso(data);
      this.cantidad = 1;
      this.cantidad_entregada = 1;
      this.precio_unitario = 1;
      this.materialStore.materiales = [];

      if(this.nuevoIngreso.length !== 0){
        this.getHistoriaL()
      }

    } else {
      Alert.error('La cantidad debe ser mayor a 0, la cantidad debe ser mayor o igual a la cantidad entregada')
      return false
    }
  }
  deleteMaterial(id:number){
    const data = {
      id: id,
      ingreso: this.nuevoIngreso.numero
    }
    this.ingresolService.deleteMaterialIngreso(data);
    if(this.nuevoIngreso.length !== 0){
      this.getHistoriaL()
    }
  }

  updateQuantity(material:object, cantidad_entregada:number){
    const data = {
      material: material,
      ingreso: this.nuevoCodigo,
      cantidad_entregada: cantidad_entregada
    }
    this.ingresolService.updateQuantity(data);
  }


  deleteMaterialesIngreso(){
    const data = {
      ingreso: this.nuevoIngreso.numero
    }
    this.ingresolService.deleteMaterialesIngreso(data);
    if(this.nuevoIngreso.length !== 0){
      this.getHistoriaL()
    }
  }

  finalizarIngreso(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Esta seguro de finalizar el ingreso? <br>
                    Una vez aceptado se procedera a afectar las cantidades de los materiales ingresados <br>
                    Revise bien por favor`
    ).then(res => {
      const data = {ingreso:this.ingreso, numero:this.nuevoIngreso.numero}
      if (res.isConfirmed) {
        this.ingresolService.finalizarIngreso(data);
        this.$emit('listar')
      }
    })
    if(this.nuevoIngreso.length !== 0){
      this.getHistoriaL()
    }

  }


  escogerDocumento(event: any) {
    this.files = event.target.files;
  }

  async save() {
    //let url = "cargarDocumento/" + this.nuevoCodigo;
    let formData = new FormData();

    //cargando varios archivos para enviarlo al servidor
    for (let i = 0; i < this.files.length; i++) {
      let file = this.files[i];
      formData.append("url[" + i + "]", file);
    }

    let headers = {'Content-Type': 'multipart/form-data'};

    //const data = {url,formData,config}
      this.ingresolService.adjuntarDocumento(this.nuevoIngreso.id,formData, headers);


  }


  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde el Ingreso')
      return false
    }
    this.ingresolService.imprimirIngreso(id);

  }





}
